// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"9acca8d3","453":"07b05b3f","835":"4caf002a"}[chunkId] + ".chunk.js";
};